module.exports = __webpack_public_path__ + "img/B3.52e71d28.jpg";